module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product productOrder"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentOrder.attributes.product_specimens))])]), _vm._v(" "), _c('div', {
    staticClass: "info2"
  }, [_c('p', [_vm._v(_vm._s(_vm.setCounterItems))])]), _vm._v(" "), _c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag tag-alta"
  }, [(_vm.currentOrder.attributes.warning_expired_flag == 1) ? _c('p', {
    staticClass: "tag"
  }, [_vm._v("Con retraso")]) : (_vm.currentOrder.attributes.warning_expired_flag == 0 && _vm.currentOrder.attributes.items_to_replace > 0) ? _c('p', {
    staticClass: "tag"
  }, [_vm._v("A reponer")]) : _vm._e()]), _vm._v(" "), (_vm.currentOrder.attributes.product_image_url == null) ? _c('img', {
    attrs: {
      "src": 'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png'
    }
  }) : _c('img', {
    staticClass: "img-table",
    attrs: {
      "src": _vm.currentOrder.attributes.product_image_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "productName"
  }, [_vm._v("$ " + _vm._s(_vm.currentOrder.attributes.real_price))]), _vm._v(" "), _c('span', {
    staticClass: "productCode"
  }, [_vm._v("#" + _vm._s(_vm.currentOrder.attributes.order_code))]), _vm._v(" "), _c('span', {
    staticClass: "productName"
  }, [_vm._v(_vm._s(_vm.currentOrder.attributes.weight_kg) + " Kg")]), _vm._v(" "), _c('span', {
    staticClass: "productName product-truncate bold"
  }, [_vm._v(_vm._s(_vm.currentOrder.attributes.product_info))])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.setCounterItems),
      expression: "setCounterItems"
    }],
    staticClass: "num ctrl-num",
    attrs: {
      "type": "number",
      "onkeydown": "return false",
      "min": 1,
      "max": _vm.currentOrder.attributes.available_items_to_package
    },
    domProps: {
      "value": (_vm.setCounterItems)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.setCounterItems = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.equipaje === '') ? _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.alertAddPackage
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]) : _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.alertAddPackage
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c57e84fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/items/card-list-orders.vue
// module id = 1912
// module chunks = 1